// Multi-source helpers shared by the Course Tracker, "What to use instead" and
// Medication notes admin surfaces. A source is { url, label } where the label
// is the patient-facing note (e.g. "FDA label §17 Patient counseling").

export const ALLOWED_DOMAINS = [
  "dailymed.nlm.nih.gov", "pubmed.ncbi.nlm.nih.gov", "ncbi.nlm.nih.gov",
  "fda.gov", "aad.org", "jaad.org", "dermnetnz.org", "cochranelibrary.com",
  "drugs.com", "medscape.com",
];

export function isAllowedUrl(url) {
  if (!url || !/^https:\/\//i.test(url)) return false;
  try {
    const host = new URL(url).hostname.toLowerCase();
    return ALLOWED_DOMAINS.some((d) => host === d || host.endsWith("." + d));
  } catch { return false; }
}

const DOMAIN_DISPLAY = [
  ["dailymed.nlm.nih.gov", "FDA label"],
  ["fda.gov", "FDA"],
  ["pubmed.ncbi.nlm.nih.gov", "PubMed"],
  ["ncbi.nlm.nih.gov", "PubMed"],
  ["aad.org", "AAD guideline"],
  ["jaad.org", "JAAD"],
  ["dermnetnz.org", "DermNet NZ"],
  ["cochranelibrary.com", "Cochrane review"],
  ["drugs.com", "Drugs.com"],
  ["medscape.com", "Medscape"],
];

export function sourceDisplayName(url) {
  try {
    const host = new URL(url).hostname.toLowerCase();
    for (const [d, n] of DOMAIN_DISPLAY) {
      if (host === d || host.endsWith("." + d)) return n;
    }
  } catch { /* ignore */ }
  return "Clinical source";
}

export function prettySection(n, text) {
  const t = (text || "").trim();
  const nice = t ? t.charAt(0).toUpperCase() + t.slice(1).toLowerCase() : "";
  return `§${n}${nice ? " " + nice : ""}`;
}

// Label when citing an FDA label section from the panel's "Use" button.
export function fdaUseLabel(sec) {
  return `FDA label ${prettySection(sec.n, sec.label)}`.trim();
}

export function autoLabel(url, note) {
  return (note || "").trim() || sourceDisplayName(url);
}
